import React, { useMemo, useState } from "react";
import { ClickAwayListener, Popper } from "@mui/material";
import { flexRender } from "@tanstack/react-table";
import CellContainer from "../cellContainer";
import PricingGuidanceCard from "../../BulkReprice/PricingGuidanceCard";

const BandRangeCell = ({ cell }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const guidanceData = useMemo(() => {
    const source = cell?.row?.original ?? {};

    const bandHigh = cell.row.original["Band High"];
    const bandLow = cell.row.original["Band Low"];

    const isPresent = (value) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !Number.isNaN(Number(value));

    if (!isPresent(bandHigh) && !isPresent(bandLow)) {
        return "-";
    }
                
              
    return {
      confidence: source["Confidence"],
      bandLow: source["Band Low"],
      bandHigh: source["Band High"],
      suggested: source["Suggested Price"],
      ask: source["$/Ct"],
      bestComp: source["Best Compition Price"],
      direction: source["Direction"],
      position: source["Position"],
      ppcPredicted: source["PPC Predicted"],
      ppcPredictedFrom: source["PPC Predicted From"],
      ppcPredictedTo: source["PPC Predicted To"],
    };
  }, [cell?.row?.original]);

  const hasGuidance = useMemo(() => {
      const { bandLow, bandHigh, suggested, position } = guidanceData;
      return [bandLow, bandHigh, suggested, position].some(
        (value) => value !== null && value !== undefined && value !== ""
      );
    }, [guidanceData]);

  const handleMouseEnter = (event) => {
    if (!hasGuidance) return;
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  return (
    <>
      <Popper
        open={Boolean(anchorEl) && hasGuidance}
        anchorEl={anchorEl}
        placement="bottom"
        style={{ zIndex: 1000 }}
        
      >
        <ClickAwayListener onClickAway={handleClose}>
           <div className="w-full bg-white border border-[#cbcbcb] rounded-xl px-1 py-2 shadow-md">
            <PricingGuidanceCard band={guidanceData} />
          </div>
        </ClickAwayListener>
      </Popper>
      <td
        key={cell.id}
        className="h-10"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleClose}
      >
        <CellContainer className="text-[0.685rem] font-medium mt-1 justify-end px-3 text-end">
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </CellContainer>
      </td>
    </>
  );
};

export default BandRangeCell;

